import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, inject } from 'vue';

import { Heading } from '@warrenbrasil/nebraska-web';
import { AllocationChart } from '@/modules/wealth/components/AllocationChart';
import { AllocationChartProducts } from './components/AllocationChartProducts';
import { moneyFormat } from '@/modules/common/helpers/currency';

import { IPortfolioDistributionResponse } from '@/modules/wallet-builder/src/services/types/models/IBffInvestments';

interface Props {
  isLoading?: boolean;
  hasError?: boolean;
}

interface Emits {
  (e: 'on-retry'): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Allocation',
  props: {
    isLoading: { type: Boolean, default: false },
    hasError: { type: Boolean, default: false }
  },
  emits: ["on-retry"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'on-retry'): void;
}), expose: any, slots: any, attrs: any }) {





const portfolioDistribution = ref<IPortfolioDistributionResponse | undefined>(
  inject<IPortfolioDistributionResponse>('portfolioDistribution')
);

const totalBalance = computed(() => {
  return moneyFormat(portfolioDistribution.value?.portfolio?.totalBalance || 0);
});

const updatedAt = computed(() => {
  return portfolioDistribution.value?.appliedAllocations?.lastUpdateAt
    ? `Atualizado em ${portfolioDistribution.value?.appliedAllocations?.lastUpdateAt}`
    : '';
});

const sections = computed(() => {
  const isVirtual = portfolioDistribution.value?.portfolio?.isVirtual;

  if (isVirtual || isVirtual === undefined) return plannedSections.value;

  return appliedSections.value;
});

const appliedSections = computed(() => {
  let sectionList = portfolioDistribution.value?.appliedAllocations.data?.map(
    allocation => {
      return {
        isApplied: true,
        color: allocation.typeColor,
        ...allocation
      };
    }
  );

  sectionList =
    portfolioDistribution.value?.appliedAllocations.classSummary?.map(
      (allocation, index) => {
        return {
          ...sectionList![index],
          name: allocation.name.formatted,
          balance: {
            value: allocation.amount.value,
            formatted: allocation.amount.formatted
          }
        };
      }
    );

  return sectionList || [];
});

const plannedSections = computed(() => {
  const sectionList = portfolioDistribution.value?.plannedAllocations.data?.map(
    allocation => {
      return {
        isApplied: false,
        name: allocation.label.formatted,
        balance: {
          value: allocation.allocValue.value,
          formatted: allocation.allocValue.formatted
        },
        color: allocation.typeColor,
        ...allocation
      };
    }
  );

  return sectionList || [];
});

function emitOnRetry() {
  emits('on-retry');
}

return { __sfc: true,emits, portfolioDistribution, totalBalance, updatedAt, sections, appliedSections, plannedSections, emitOnRetry, Heading, AllocationChart, AllocationChartProducts }
}

})